import Free from '../Info/Icons/Free';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FeaturePopup({ content, show, callback }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    const I18N: any = {
        us: 'Details',
        jp: '説明',
    };

    return (
        <>
            {show ? (
                <section className={`product-brief-guide-popup ${css['product-brief-guide-popup']}`}>
                    <div className="popup-content">
                        <h4 className="popup-header">
                            <span className="header-title">{I18N[locale] || I18N.us}</span>
                            <svg
                                className="header-close"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                onClick={callback}
                            >
                                <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </h4>
                        <div className="popup-main">
                            <ul className="popup-items">
                                <li className="popup-item">
                                    <p className="item-desc">
                                        <span>
                                            {content?.details}
                                            {content?.text === 'icon_eco_credits' && (
                                                <>
                                                    {locale != 'jp' ? (
                                                        <>
                                                            (
                                                            <a
                                                                className="a"
                                                                href={`https://${locale}.ecoflow.com/`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >{`${locale}.ecoflow.com`}</a>
                                                            ).
                                                        </>
                                                    ) : (
                                                        <>
                                                            <a className="a" href="https://jp.ecoflow.com/" target="_blank" rel="noreferrer">
                                                                jp.ecoflow.com
                                                            </a>
                                                            ）で販売中のDELTA Pro Ultraスタンダードセット、DELTA Pro Ultraソーラー発電セット、DELTA Pro
                                                            Ultraトリプルバッテリーセットです
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </span>
                                        {content?.text === 'icon_free' && (
                                            <>
                                                {' '}
                                                <Free />
                                            </>
                                        )}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            ) : null}
        </>
    );
}
